import React from 'react';
import TransferList from 'app/components/transferModule/content/TransferList';
import { TransfersPerView } from 'app/components/transferModule/types/TransfersPerView';
import { OnlyDesktop, OnlyMobile } from 'app/components/transferModule/content/commonStyles';
export default function ResponsiveTransferList(_ref) {
  let {
    transfers
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(OnlyDesktop, {
    "data-sentry-element": "OnlyDesktop",
    "data-sentry-source-file": "ResponsiveTransferList.tsx"
  }, /*#__PURE__*/React.createElement(TransferList, {
    transfers: transfers,
    transfersPerView: TransfersPerView.Desktop,
    "data-sentry-element": "TransferList",
    "data-sentry-source-file": "ResponsiveTransferList.tsx"
  })), /*#__PURE__*/React.createElement(OnlyMobile, {
    "data-sentry-element": "OnlyMobile",
    "data-sentry-source-file": "ResponsiveTransferList.tsx"
  }, /*#__PURE__*/React.createElement(TransferList, {
    transfers: transfers,
    transfersPerView: TransfersPerView.Mobile,
    "data-sentry-element": "TransferList",
    "data-sentry-source-file": "ResponsiveTransferList.tsx"
  })));
}